import { useEffect, useState } from 'react'
import { receiveDemoSessionHandoff } from '../demoSession.js'

/**
 * What a tab shows while it waits for its opener to hand it a demo
 * session. On success the tab reloads at the clean path, signed in; on
 * failure it says why, so a blocked or refused session is not a blank page.
 */
export function DemoSessionHandoff() {
  const [failure, setFailure] = useState<string | null>(null)
  useEffect(() => receiveDemoSessionHandoff(setFailure), [])
  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center p-8">
      <div className="max-w-md bg-white border border-marine/15 p-6 text-center">
        <div className="text-[9px] font-bold uppercase tracking-[2.5px] text-coral mb-2">autonoME</div>
        {failure ? (
          <>
            <div className="text-sm font-extrabold text-ink mb-1">The demo session could not be opened</div>
            <p className="text-xs text-ink-mid leading-relaxed">{failure}</p>
            <p className="text-xs text-ink-mid mt-3">Close this tab and try again from where you opened it.</p>
          </>
        ) : (
          <>
            <div className="text-sm font-extrabold text-ink mb-1">Opening a demo session…</div>
            <p className="text-xs text-ink-mid leading-relaxed">This tab is waiting for the session from the tab that opened it. Nothing is typed or stored outside this tab.</p>
          </>
        )}
      </div>
    </div>
  )
}
